(() => {
  const element = document.getElementById('SvhaineLocalizationContext');
  const automaticForm = document.getElementById('SvhaineAutomaticLocalization');
  if (!element || !automaticForm) return;
  let context;
  try { context = JSON.parse(element.textContent); } catch { return; }
  const prefix = 'svhaine.localization.v1.';
  const countries = context.countries || [];
  const languages = context.languages || [];
  const storage = (scope, key, value) => {
    try {
      const target = window[scope];
      if (value === undefined) return target.getItem(prefix + key);
      target.setItem(prefix + key, value);
      return true;
    } catch { return null; }
  };
  const supports = (values, value) => Boolean(value && values.includes(value));
  const panel = document.getElementById('SvhaineLocalizationDialog');
  const preferences = document.getElementById('SvhainePreferences');
  const search = document.getElementById('SvhaineCountrySearch');
  let opener;
  document.querySelectorAll('[data-sv-drawer]').forEach(drawer => {
    const syncDrawer = () => drawer.setAttribute('aria-hidden', String(!drawer.classList.contains('is-open')));
    new MutationObserver(syncDrawer).observe(drawer, {attributes: true, attributeFilter: ['class']});
    syncDrawer();
  });
  const normalize = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase();
  const resetSearch = () => {
    if (!panel || !search) return;
    search.value = '';
    panel.querySelectorAll('[data-sv-country]').forEach(row => { row.hidden = false; });
    panel.querySelectorAll('[data-sv-region]').forEach(region => { region.hidden = false; });
    panel.querySelector('[data-sv-country-empty]').hidden = true;
  };
  document.addEventListener('click', event => {
    const open = event.target.closest?.('[data-sv-locale-open]');
    if (open && panel) {
      opener = open;
      preferences.reset();
      resetSearch();
      panel.querySelectorAll('details').forEach(details => { details.open = false; });
      panel.showModal();
      panel.querySelector('#SvhaineCountryList').scrollTop = 0;
      document.querySelectorAll('[data-sv-locale-open]').forEach(trigger => trigger.setAttribute('aria-expanded', 'true'));
    }
    if (panel?.open) {
      const rect = panel.getBoundingClientRect();
      const outside = event.target === panel && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom);
      if (event.target.closest?.('[data-sv-locale-close]') || outside) panel.close();
    }
  });
  panel?.addEventListener('close', () => {
    document.querySelectorAll('[data-sv-locale-open]').forEach(trigger => trigger.setAttribute('aria-expanded', 'false'));
    opener?.focus();
  });
  search?.addEventListener('input', () => {
    const terms = normalize(search.value.trim()).split(/\s+/).filter(Boolean);
    let matches = 0;
    panel.querySelectorAll('[data-sv-country]').forEach(row => {
      const text = normalize(row.dataset.search);
      row.hidden = !terms.every(term => text.includes(term));
      if (!row.hidden) matches++;
    });
    panel.querySelectorAll('[data-sv-region]').forEach(region => {
      region.hidden = !region.querySelector('[data-sv-country]:not([hidden])');
    });
    panel.querySelector('#SvhaineCountryList').scrollTop = 0;
    panel.querySelector('[data-sv-country-empty]').hidden = matches > 0;
  });
  const languageFromPath = path => {
    const first = path.split('/')[1].toLowerCase();
    return languages.find(language => language.toLowerCase() === first) || context.defaultLanguage;
  };
  const returnPath = () => {
    const url = new URL(window.location.href);
    const first = url.pathname.split('/')[1];
    if (languages.some(language => language.toLowerCase() === first.toLowerCase())) url.pathname = url.pathname.slice(first.length + 1) || '/';
    url.searchParams.delete('country');
    url.searchParams.delete('country_code');
    url.searchParams.delete('language_code');
    return url.pathname + url.search + url.hash;
  };
  const updateReturnPath = form => {
    let fields = form.querySelectorAll('input[name="return_to"]');
    if (!fields.length) {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'return_to';
      form.appendChild(input);
      fields = [input];
    }
    fields.forEach(input => { input.value = returnPath(); });
  };
  let interacted = false;
  document.addEventListener('pointerdown', () => { interacted = true; }, {once: true, passive: true});
  document.addEventListener('keydown', () => { interacted = true; }, {once: true});
  document.addEventListener('change', event => {
    const input = event.target;
    if (!input || !input.form || input.form === automaticForm) return;
    if (input.name === 'country_code') {
      if (input.form !== preferences) storage('localStorage', 'country', input.value);
    } else if (input.name === 'language_code' || input.name === 'locale_code') {
      if (input.form !== preferences) storage('localStorage', 'language', input.value);
    }
    else return;
    interacted = true;
    updateReturnPath(input.form);
  }, true);
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!form || form === automaticForm || !form.querySelector('[name="country_code"],[name="language_code"],[name="locale_code"]')) return;
    if (panel?.contains(form)) {
      const country = form.elements.namedItem('country_code')?.value;
      const language = form.elements.namedItem('language_code')?.value;
      if (country) storage('localStorage', 'country', country);
      if (language) storage('localStorage', 'language', language);
      panel.setAttribute('aria-busy', 'true');
      panel.querySelectorAll('button[type="submit"]').forEach(button => { button.disabled = true; });
    }
    updateReturnPath(form);
  }, true);
  window.addEventListener('pageshow', () => {
    panel?.removeAttribute('aria-busy');
    panel?.querySelectorAll('button[type="submit"]').forEach(button => { button.disabled = false; });
  });
  document.addEventListener('click', event => {
    const link = event.target.closest?.('a.svhaine-dd__link');
    if (!link) return;
    const target = new URL(link.href, window.location.origin);
    if (target.origin !== window.location.origin) return;
    storage('localStorage', 'language', languageFromPath(target.pathname));
    interacted = true;
  }, true);
  document.addEventListener('change', event => {
    if (event.target.matches('[data-sv-localization-select]')) event.target.form.requestSubmit();
  });
  if (context.designMode || window.Shopify?.designMode || /bot|crawler|spider|lighthouse/i.test(navigator.userAgent)) return;
  if (storage('sessionStorage', 'checked')) return;
  if (!storage('sessionStorage', 'checked', '1')) return;
  const currentUrl = new URL(window.location.href);
  const explicitCountry = currentUrl.searchParams.get('country') || currentUrl.searchParams.get('country_code');
  if (supports(countries, explicitCountry)) storage('localStorage', 'country', explicitCountry);
  const preferredCountry = storage('localStorage', 'country');
  const preferredLanguage = storage('localStorage', 'language');
  const path = currentUrl.pathname.toLowerCase();
  const explicitLanguage = languages.find(language => language !== context.defaultLanguage &&
    (path === '/' + language.toLowerCase() || path.startsWith('/' + language.toLowerCase() + '/')));
  const browserLanguages = (navigator.languages || [navigator.language]).map(language => (language || '').toLowerCase());
  const matchLanguage = value => {
    const exact = languages.find(language => language.toLowerCase() === value);
    if (exact) return exact;
    if (value.split('-')[0] === 'zh') {
      const chinese = /-(tw|hk|mo|hant)(?:-|$)/.test(value) ? 'zh-TW' : 'zh-CN';
      if (supports(languages, chinese)) return chinese;
    }
    return languages.find(language => language.toLowerCase().split('-')[0] === value.split('-')[0]);
  };
  const browserLanguage = browserLanguages.map(matchLanguage).find(Boolean);
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), 3000);
  fetch((context.root || '/').replace(/\/?$/, '/') + 'browsing_context_suggestions.json?country[enabled]=true&language[enabled]=true', {
    credentials: 'same-origin', signal: controller.signal, headers: {'Accept': 'application/json'}
  }).then(response => {
    if (!response.ok) throw new Error('Localization unavailable');
    return response.json();
  }).then(data => {
    if (interacted) return;
    const parts = data.suggestions?.[0]?.parts || {};
    const detectedCountry = data.detected_values?.country?.handle || parts.country?.handle;
    const country = supports(countries, preferredCountry) ? preferredCountry :
      supports(countries, detectedCountry) ? detectedCountry : context.country;
    const language = explicitLanguage || (supports(languages, preferredLanguage) ? preferredLanguage :
      browserLanguage) ||
      (supports(languages, parts.language?.handle) ? parts.language.handle : context.language);
    if (country === context.country && language === context.language) return;
    automaticForm.elements.namedItem('country_code').value = country;
    automaticForm.elements.namedItem('language_code').value = language;
    updateReturnPath(automaticForm);
    automaticForm.submit();
  }).catch(() => {}).finally(() => clearTimeout(timeout));
})();

